/**
 * row-status-tooltip.js
 */

import React from 'react';
import { Typography, Tooltip } from '@mui/material';


import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  tooltipItem: {
    margin: `${theme.spacing(1)} 0`,
    '& .label': {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: theme.spacing(1),
      '& .status': {
        fontSize: theme.typography.sizes[0],
        fontWeight: 300,
        lineHeight: 1,
        color: theme.palette.sys.onPrimaryVariant
      }
    }
  }
}));


export default function RowStatusTooltip(props) {
  const { items, children } = props;
  const classes = useStyles();
    
  let tooltip = '';

  if (items?.length > 0)
  {
    tooltip = items.map(item => 
      <div key={item.id} className={`flex-hc ${classes.tooltipItem}`}>
        {item.icon}
        <div className='label'>
          <Typography variant='caption'>{item.name}</Typography>
          <Typography variant='caption' className='status'>{item.status}</Typography>
        </div>
      </div>)
  }


  return (
    <Tooltip
      arrow
      placement='top'
      style={{ position: 'relative', display: 'flex' }}
      title={tooltip}
    >
      <div>
        {children}
      </div>
    </Tooltip>
  )
}